import {Notifications} from "@material-ui/icons";
import {useProviderEventUnreadState} from "./ProviderEventUnreadCount";
import React from "react";

export const NotificationMenuOption = () => {
    return (
        <div className="flex items-center">
            <div>
                <i className="fa-solid fa-bell"/>
                Notification
            </div>
            <Counter />
        </div>
    );
}

const Counter = () => {
    const notificationState = useProviderEventUnreadState();
    if (notificationState.loading) {
       return <div className="ml-2 loader ease-linear rounded-full border-2 border-t-4 border-gray-200 h-6 w-6"/>
    }
    if (notificationState.notificationsCount === 0) {
       return <></>
    }

    return (
        <div className="ml-2 inline-flex px-2 py-1 text-xs font-bold leading-none text-red-100 bg-red-600 rounded-full">
            {notificationState.notificationsCount > 9 ? "9+" : notificationState.notificationsCount}
        </div>
    );
}
